export default __webpack_public_path__ + "static/ux-ui-and-programming-development-technology-2fab5a9f793f0af1b3b939628893bbbd.jpg";